import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import OrderBox from "./OrderBox";
import { getMemberActionIsRead, getOrders } from "../../actions/memberActions";
import { isUserAuthenticated } from "../../helpers/authUtils";
import isEmpty from '../../validation/is-empty';
import './orderlist.css';

class OrderList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      start_date: "",
      end_date: "",
      startDayType: "text",
      endDayType: "text",
      error: {}
    };

    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onChange = this.onChange.bind(this);
  }
  
  componentDidMount = () => {
    this.props.getMemberActionIsRead();
    document.body.style.color = "#191a1c";
  };

  componentDidUpdate(prevProps) {
    if (this.props.errors !== prevProps.errors) {
      this.setState({ error: this.props.errors });
    }
  };

  onClick(e) {
    e.preventDefault();
    const { start_date,  end_date} = this.state;

    let error = {};

    if (isEmpty(start_date)) {
      error.end_date= "請選擇欲查詢的日期";
    }

    if (isEmpty(end_date)) {
      error.end_date= "請選擇欲查詢的日期";
    }

    if (!isEmpty(error)){
      this.setState({ error: error });
    } else {
      this.setState({ error: {} });
      this.props.getOrders({start_date: start_date, end_date: end_date});
    }
  }

  onChange(e) {
    //console.log(e.target.name, e.target.value)
    this.setState({ [e.target.name]: e.target.value });
  }
  
  onFocus(e) {
    if (e.target.name === "start_date") {
      this.setState({ startDayType: "date" });
    } else {
      this.setState({ endDayType: "date" });
    }
  }

  onBlur(e) {
    if (e.target.name === "start_date") {
      this.setState({ startDayType: "text" });
    } else {
      this.setState({ endDayType: "text" });
    }
  }

  renderRedirectToRoot = () => {
    const isAuthTokenValid = isUserAuthenticated();
    if (!isAuthTokenValid) {
      return <Redirect to="/members" />;
    }
  };

  render() {
    const isAuthTokenValid = isUserAuthenticated();
    const { isRead, orders } = this.props;
    const { start_date, end_date, startDayType, endDayType, error } = this.state;

    const yyIndex_min = new Date().getFullYear()-1;
    const yyIndex_max = new Date().getFullYear();
    const mm = new Date().getMonth()+1 < 10 ? '0'+(new Date().getMonth()+1) : new Date().getMonth()+1;
    const dd = new Date().getDate() < 10 ? '0'+(new Date().getDate()) : new Date().getDate();

    let orderBox;
    if (orders.length === 0) {
      orderBox = null;
    } else {
      orderBox = orders
        .map((order, idx) => <OrderBox key={`order-${idx}`} order={order} idx={idx} />);
    }

    return (
      <Fragment>
        {this.renderRedirectToRoot()}
        {(isAuthTokenValid) && (
        <div id="page">
          <Navbar isRead={isRead} />
          <aside className="colorlib-breadcrumbs">
            <div className="container">
            <div className="row">
              <div className="col-md-12 breadcrumbs text-center">
              <h2>會員直儲交易紀錄查詢</h2>
              <p><span>transaction records</span></p>
              </div>
            </div>
            </div>
          </aside>
          <div className="colorlib">
            <div className="container">
              <form>
              <div className="form-group" style={{justifyContent: "center", display: "grid"}}>
                <input id="start_date" name="start_date" placeholder="起始日期(2000/01/01)" className="form-control" style={{width: "250px", marginLeft: "-100px"}} type={startDayType} 
                value={start_date} /*min={`${yyIndex_min}-${mm}-${dd}`} max={`${yyIndex_max}-${mm}-${dd}`} onFocus={this.onFocus} onBlur={this.onBlur}*/ onChange={this.onChange} />
              </div>              
              
              <div className="form-group" style={{justifyContent: "center", display: "grid"}}>
                <input id="end_date" name="end_date" placeholder="結束日期(2000/01/01)" className="form-control" style={{width: "250px", marginLeft: "-100px"}} type={endDayType} 
                value={end_date} /*min={`${yyIndex_min}-${mm}-${dd}`} max={`${yyIndex_max}-${mm}-${dd}`} onFocus={this.onFocus} onBlur={this.onBlur}*/ onChange={this.onChange} />
                <button type="button" className="btn-query" onClick={this.onClick}>查詢</button>
              </div>              
                {error.end_date && (
                <span className="wrong_msg" style={{marginTop: "-60px"}}><img src="img/icon_wrong.svg" alt="" />{error.end_date}</span> )} 
                
                <center><div style={{marginTop: "-30px", marginBottom: "30px"}}><font color="yellow">交易紀錄僅能查詢官網直儲、官方LINE群直儲之紀錄</font></div></center>
              </form>
            </div>
            {orderBox}
          </div>
          <Footer showAgreement={true} />
        </div>
        )}
      </Fragment>
    );
  }
}

OrderList.propTypes = {
  getMemberActionIsRead: PropTypes.func.isRequired,
  getOrders: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  isRead: state.member.isRead,
  errors: state.errors,
  orders: state.member.orders,
});

export default connect(mapStateToProps, { getOrders, getMemberActionIsRead })(OrderList);